module.exports = __webpack_public_path__ + "static/img/ai.4b8d641.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/ai.png
// module id = GK6a
// module chunks = 12